export var Breakpoints = {
  DESKTOP: 1024
};